import * as Sentry from "@sentry/react";
import { Component } from "react";
import type { ReactNode, ErrorInfo } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    Sentry.captureException(error, {
      contexts: { react: { componentStack: info.componentStack } },
    });
    console.error("[ErrorBoundary]", error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4 text-center">
          <p className="text-7xl font-bold text-muted-foreground/30">500</p>
          <h1 className="mt-4 text-2xl font-semibold text-foreground">Algo deu errado</h1>
          <p className="mt-2 max-w-sm text-sm text-muted-foreground">
            Ocorreu um erro inesperado na aplicação.
          </p>
          <button
            onClick={() => { this.setState({ hasError: false }); globalThis.location.href = "/dashboard"; }}
            className="mt-8 inline-flex h-9 items-center rounded-md bg-primary px-4 text-sm font-medium text-primary-foreground hover:opacity-90"
          >
            Ir para o dashboard
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
